import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36,
        justifyContent: 'flex-start',
        width: '50%'
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
});

const BillFrom = () => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Bill From :</Text>
        <Text>Chintamani Paving</Text>
        <Text>Plot. No.: 34/A, Lane 2 New MIDC Sawardi,</Text>
        <Text>Nagpur Road, Nandgaon</Text>
        <Text>Peth Dist. Amravati 444902</Text>
        <Text>+91-8605 956751</Text>
        <Text>+91-9699 187001</Text>
    </View>
);

export default BillFrom;